import type { AuthReplayErrorContext } from '../types/auth-replay-types'

/**
 * 单个原始请求连续 unauthorized 次数超过上限时抛出的结构化错误。
 *
 * 设计说明：重放后仍 401 可能是短 token 与长下载并发下的正常现象；因此先允许有限次
 * refresh/replay，超过上限后再向调用方暴露明确错误，避免无限循环。
 */
export class AuthReplayLimitExceededError extends Error {
  /** 请求入口类型。 */
  public readonly requestKind: AuthReplayErrorContext['requestKind']
  /** 请求操作名称或 URL。 */
  public readonly operation: string
  /** 下载文件 ID。 */
  public readonly fileId?: string
  /** 下载 URL。 */
  public readonly url?: string
  /** Range 字节范围。 */
  public readonly range?: string
  /** 当前连续 unauthorized 次数。 */
  public readonly attemptCount: number
  /** 最近一次 HTTP 状态码。 */
  public readonly status?: number
  /** 最近一次 RPC 错误码。 */
  public readonly code?: number
  /** 最近一次 unauthorized 的原始原因。 */
  public override readonly cause: unknown

  /**
   * 创建鉴权重放超限错误。
   *
   * @param context 当前原始请求的鉴权重放上下文。
   */
  public constructor(context: AuthReplayErrorContext) {
    super(
      `auth replay limit exceeded: requestKind=${context.requestKind}, `
      + `operation=${context.operation}, attemptCount=${context.attemptCount}`,
    )
    this.name = 'AuthReplayLimitExceededError'
    this.requestKind = context.requestKind
    this.operation = context.operation
    this.fileId = context.fileId
    this.url = context.url
    this.range = context.range
    this.attemptCount = context.attemptCount
    this.status = context.status
    this.code = context.code
    this.cause = context.cause
  }
}
